/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagesplanDto } from '../../models/tagesplan-dto';

export interface GetTagesplaene$Plain$Params {
  onlySoftDeletes?: boolean;
}

export function getTagesplaene$Plain(http: HttpClient, rootUrl: string, params?: GetTagesplaene$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagesplanDto>>> {
  const rb = new RequestBuilder(rootUrl, getTagesplaene$Plain.PATH, 'get');
  if (params) {
    rb.query('onlySoftDeletes', params.onlySoftDeletes, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagesplanDto>>;
    })
  );
}

getTagesplaene$Plain.PATH = '/v1/tagesplaene';
